
<div class="accions">
  <label>L'acció que se us recomana és la destacada amb color entre les següents:</label>
  <br/>
  <div [ngClass]="{accio: true, ambBorde: resultat.gravetatRisc.accio == '1'}" [ngStyle]="{'border-color': resultat.gravetatRisc.accio == '1' ? resultat.gravetatRisc.colorSemafor : ''}">
    <label class="center">{{accions[0].titolAccioSimulacio}}</label>
    <div>
      <strong>{{accions[0].textPrefAccioSimulacio}}</strong> {{accions[0].textAccioSimulacio}}
    </div>
  </div>
  <div [ngClass]="{accio: true, ambBorde: resultat.gravetatRisc.accio == '2'}" [ngStyle]="{'border-color': resultat.gravetatRisc.accio == '2' ? resultat.gravetatRisc.colorSemafor : ''}">
    <label class="center">{{accions[1].titolAccioSimulacio}}</label>
    <div>
      <strong>{{accions[1].textPrefAccioSimulacio}}</strong> {{accions[1].textAccioSimulacio}}
    </div>
  </div>
  <div [ngClass]="{accio: true, ambBorde: resultat.gravetatRisc.accio == '3'}" [ngStyle]="{'border-color': resultat.gravetatRisc.accio == '3' ? resultat.gravetatRisc.colorSemafor : ''}">
    <label class="center">{{accions[2].titolAccioSimulacio}}</label>
    <div>
      <strong>{{accions[2].textPrefAccioSimulacio}}</strong> {{accions[2].textAccioSimulacio}}
    </div>
  </div>
</div>

<div class="button-bar">
  <button class="main" (click)="goToPrevStep()"><i class="fas fa-angle-left prev" aria-hidden></i> {{'globals.anterior' | translate}}</button>
  <button class="main" (click)="imprimir()">{{'globals.imprimir' | translate}}</button>
</div>